export const MEDICATIONS = [
  "Paracetamol",
  "Ibuprofen",
  "Amoxicillin",
  "Tobramycin eye drops",
  "Azithromycin",
  "Cefixime",
  "Omeprazole",
  "Vitamin D3",
  "Metformin",
  "Amlodipine",
  "test"
];

export const DOSE_OPTIONS = [1, 2, 3, 4, 5, 6];
export const UNIT_OPTIONS = [
  { label: "comprimé", abbr: "cp" },
  { label: "gélule", abbr: "gél" },
  { label: "millilitre", abbr: "mL" },
  { label: "cuillère à café", abbr: "c.à.c" },
  { label: "cuillère à soupe", abbr: "c.à.s" },
  { label: "dose dépendante du poids", abbr: "DDP" },
  { label: "ampoule buvable", abbr: "amp buv" },
  { label: "ampoule injectable", abbr: "amp inj" },
  { label: "sachet", abbr: "sach" },
  { label: "goutte", abbr: "gtt" },
  { label: "application", abbr: "app" },
  { label: "pulvérisation", abbr: "pulv" },
  { label: "spray", abbr: "spray" },
  { label: "bouffée", abbr: "bouf" },
  { label: "rinçage", abbr: "rinçage" },
  { label: "gargarisme", abbr: "gargar" },
  { label: "utilisation buccale", abbr: "util bucc" },
  { label: "patch", abbr: "patch" },
  { label: "suppositoire", abbr: "supp" },
  { label: "ovule", abbr: "ov" },
  { label: "ampoule", abbr: "amp" },
  { label: "flacon", abbr: "fl" },
  { label: "seringue", abbr: "ser" },
  { label: "unité internationale", abbr: "UI" },
  { label: "carpule", abbr: "carp" },
  { label: "cartouche", abbr: "cart" },
  { label: "clic", abbr: "clic" },
  { label: "pastille", abbr: "past" },
  { label: "prise", abbr: "prise" },
  { label: "milligramme", abbr: "mg" }
];
export const ROUTE_OPTIONS = [
  "oral",
  "per os",
  "sublingual",
  "orodispersible",
  "à sucer",
  "à mâcher",
  "injectable",
  "auriculaire",
  "ophtalmique",
  "nasal",
  "oropharyngé",
  "inhalé",
  "cutané",
  "buccal",
  "transdermique",
  "rectal",
  "vaginal",
  "intramusculaire (IM)",
  "intraveineux (IV)",
  "sous-cutané (SC)",
  "intrathécal",
  "perfusion IV"
];
export const FREQUENCY_OPTIONS = [
  "1x/jour",
  "2x/jour",
  "3x/jour",
  "4x/jour",
  "toutes les 6h",
  "toutes les 8h",
  "toutes les 12h",
  "toutes les 24h",
  "1x/semaine",
  "2x/semaine",
  "1x/mois"
];
export const MOMENT_OPTIONS = [
  "matin",
  "midi",
  "soir",
  "au coucher",
  "matin et soir",
  "matin midi soir",
  "matin midi soir coucher"
];
export const MEAL_OPTIONS = [
  "avant les repas",
  "pendant les repas",
  "après les repas",
  "en dehors des repas",
  "sans préférence"
];
export const DURATION_OPTIONS = [
  { label: "jours", value: "jours" },
  { label: "semaines", value: "semaines" },
  { label: "mois", value: "mois" },
  { label: "calendrier (du jour 5 au jour 20)", value: "calendrier (du jour 5 au jour 20)" }
];
export const CONDITION_OPTIONS = [
  "si douleur",
  "si fièvre",
  "si nausée",
  "si vomissements",
  "si brûlure gastrique",
  "si migraine",
  "si crise d'asthme",
  "si anxiété",
  "si insomnie",
  "si allergie"
];
export const QTY_OPTIONS = ["QSPM", "QSPJ", "boîte(s)", "ml", "unité"];
export const RENEWAL_OPTIONS = [
  "non renouvelable",
  "renouvelable 1x",
  "renouvelable 2x",
  "renouvelable 3x",
  "renouvelable 3 mois",
  "renouvelable 6 mois"
];
export const CONDITION_ACTION_OPTIONS = ["none", "add_dosage_line", "association", "relay", "create_block"];

export const createId = (prefix) => `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

export const createDosageLine = () => ({
  id: createId("line"),
  type: "dosage_line",
  dose: "",
  unite: "",
  frequence: "",
  voie: "",
  moment: "",
  repas: "",
  duree_valeur: "",
  duree_unite: "",
  duree_calendar_start: "",
  duree_calendar_end: "",
  condition: "",
  renouvellement: "",
  notes: ""
});

export const createStepLine = () => ({
  id: createId("line"),
  type: "step_line",
  dose: "",
  unite: "",
  frequence: "",
  voie: "",
  moment: "",
  repas: "",
  duree_valeur: "",
  duree_unite: "",
  duree_calendar_start: "",
  duree_calendar_end: "",
  condition: "",
  renouvellement: "",
  notes: ""
});

export const createConditionLine = () => ({
  id: createId("line"),
  type: "condition_line",
  expression: "",
  action_type: "none",
  add_line_payload: createDosageLine(),
  action_medication: "",
  spawned_block_id: ""
});

export const createTestLine = () => ({
  id: createId("line"),
  type: "test_line",
  tests: []
});

export const createLineByType = (type) => {
  if (type === "step_line") return createStepLine();
  if (type === "condition_line") return createConditionLine();
  if (type === "test_line") return createTestLine();
  return createDosageLine();
};

export const createBlock = (name = "") => ({
  id: createId("block"),
  medicament: { name },
  quantite: "",
  type_quantite: "",
  lines: [createDosageLine()],
  children: []
});

export const createPrescription = (patientProfile = {}) => ({
  id: createId("prescription"),
  patient_profile: {
    name: String(patientProfile.name || "").trim(),
    age: patientProfile.age !== undefined && patientProfile.age !== null ? String(patientProfile.age).trim() : "",
    sex: String(patientProfile.sex || "").trim(),
    is_override: false
  },
  entries: [
    {
      id: createId("entry"),
      title: "Entrée 1",
      note: "",
      isDraft: false,
      blocks: [createBlock("")]
    }
  ]
});

export const initialEngine = (patientProfile = {}) => ({
  prescriptions: [createPrescription(patientProfile)]
});

export const mapBlocks = (blocks, matcher) =>
  blocks.map((block) => {
    const next = matcher(block);
    return {
      ...next,
      children: mapBlocks(next.children || [], matcher)
    };
  });

export const findBlock = (blocks, blockId) => {
  for (const block of blocks) {
    if (block.id === blockId) return block;
    const nested = findBlock(block.children || [], blockId);
    if (nested) return nested;
  }
  return null;
};

export const flattenBlocks = (blocks, depth = 0, parentId = "") => {
  const flat = [];
  blocks.forEach((block) => {
    flat.push({ block, depth, parentId });
    flat.push(...flattenBlocks(block.children || [], depth + 1, block.id));
  });
  return flat;
};

export const lineLabel = (line, index) => {
  if (line.type === "step_line") return `Ligne étape ${index + 1}`;
  if (line.type === "condition_line") return `Ligne condition ${index + 1}`;
  if (line.type === "test_line") return `Ligne test ${index + 1}`;
  return `Ligne posologie ${index + 1}`;
};
